import projectImages from './projectImages';

/**
 * Map free-text titles (e.g. Firestore) to bundled gallery keys in projectImages.
 * Order matters: first match wins — keep specific patterns before generic ones.
 */
const TITLE_RULES = [
  { test: (t) => /curse\s+of\s+the\s+nile/i.test(t), slug: 'curse-of-the-nile' },
  { test: (t) => /dead\s*zone|deadzone/i.test(t), slug: 'deadzone' },
  { test: (t) => /sky\s*war|skywar/i.test(t), slug: 'skywar' },
  { test: (t) => /albergo|italian\s+hotel|terrore/i.test(t), slug: 'italian-hotel' },
  { test: (t) => /freddy|\bfnaf\b|five\s+nights\s+at\s+freddy/i.test(t), slug: 'fnaf' },
  { test: (t) => /vampire\s+hotel|midnight\s+manor/i.test(t), slug: 'midnight-manor' },
  { test: (t) => /\blocanda\b/i.test(t), slug: 'locanda' },
];

/**
 * Prefer explicit CMS slug when it has bundled images; otherwise infer from title
 * so featured cards open the same multi-image + video gallery as case studies.
 */
export function resolveGallerySlug(project) {
  const explicit = (project.slug && String(project.slug).trim()) || null;
  if (explicit && projectImages[explicit]?.length) return explicit;

  const title = (project.title && String(project.title).trim()) || '';
  for (const rule of TITLE_RULES) {
    if (!title || !rule.test(title)) continue;
    if (projectImages[rule.slug]?.length) return rule.slug;
  }

  return explicit;
}
